exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#tb_movement tbody tr {\n    cursor: pointer;\n}\n", ""]);

// exports
